import { join, repeat } from 'ramda'

export default (repeated) => {
  return join(',', repeat(13, repeated))
}
